import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useNavigate, useParams } from 'react-router';
import { useTheme } from '@mui/material/styles';

const TenantSwitcher = ({ tenants }) => {
	// set current tenant ID based on URI
	const { tenantId } = useParams();
	const theme = useTheme();

	// Track current tenant in state in order to control value of autocomplete
	const [currentTenant, setCurrentTenant] = useState(null);
	useEffect(() => {
		if (tenantId !== currentTenant?.id) {
			const newTenant = tenants.find(
				(tenant) => String(tenant.id) === String(tenantId)
			);
			setCurrentTenant(newTenant);
		}
	}, [tenantId, tenants, currentTenant?.id]);

	// navigate to tenant route on selection
	const navigate = useNavigate();
	const handleTenantChange = (_event, value) => {
		if (value?.id !== currentTenant?.id) {
			setCurrentTenant(value); // optimistically set
			navigate(`/tenants/${value.id}/marketplace`);
		}
	};

	return (
		<Box sx={{ minWidth: 250 }}>
			<Autocomplete
				options={tenants}
				getOptionLabel={(option) => option.name}
				value={currentTenant}
				onChange={handleTenantChange}
				renderInput={(params) => (
					<TextField
						{...params}
						variant='outlined'
						sx={{
							backgroundColor: theme.palette.background.default,
							borderRadius: '8px',
							'& .MuiOutlinedInput-root': {
								color: theme.palette.text.primary,
								backgroundColor: theme.palette.background.default,
								borderRadius: '8px',
								'& fieldset': {
									borderColor: theme.palette.divider,
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.main,
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.main,
								},
							},
							'& .MuiAutocomplete-endAdornment': {
								color: theme.palette.text.primary,
							},
						}}
						placeholder='Switch Tenant'
						InputProps={{
							...params.InputProps,
							sx: {
								backgroundColor: theme.palette.background.default,
								borderRadius: '8px',
							},
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default TenantSwitcher;
